// Liste des utilisateurs du système avec leurs rôles

export interface SystemUser {
  id: string;
  email: string;
  name: string;
  role: 'agent_terrain' | 'agence' | 'soebra' | 'admin';
  organization?: string;
  avatar?: string;
  isOnline?: boolean;
  lastSeen?: string;
}

export const mockSystemUsers: SystemUser[] = [
  // Administrateur
  {
    id: 'admin-001',
    email: 'admin@soebra.com',
    name: 'Administrateur Principal',
    role: 'admin',
    organization: 'SOBEBRA',
    isOnline: true,
  },
  // Agence
  {
    id: 'agence-001',
    email: 'agence@zenith.bj',
    name: 'Agence Zenith Productions',
    role: 'agence',
    organization: 'Agence Zenith Productions',
    isOnline: true,
  },
  {
    id: 'agence-002',
    email: 'manager@zenith.bj',
    name: 'Manager Agence',
    role: 'agence',
    organization: 'Agence Zenith Productions',
    isOnline: false,
    lastSeen: '2024-11-14T14:00:00Z',
  },
  // SOBEBRA
  {
    id: 'soebra-001',
    email: 'soebra@soebra.bj',
    name: 'SOBEBRA - Direction Marketing',
    role: 'soebra',
    organization: 'SOBEBRA',
    isOnline: true,
  },
  {
    id: 'soebra-002',
    email: 'supervisor@soebra.bj',
    name: 'Superviseur SOBEBRA',
    role: 'soebra',
    organization: 'SOBEBRA',
    isOnline: false,
    lastSeen: '2024-11-14T16:00:00Z',
  },
  // Agents Terrain
  {
    id: 'agent-001',
    email: 'agent@zenith.bj',
    name: 'Koffi Amoussou',
    role: 'agent_terrain',
    organization: 'Agence Zenith Productions',
    isOnline: true,
  },
  {
    id: 'agent-002',
    email: 'marie@zenith.bj',
    name: 'Marie Adékambi',
    role: 'agent_terrain',
    organization: 'Agence Zenith Productions',
    isOnline: false,
    lastSeen: '2024-11-14T15:30:00Z',
  },
  {
    id: 'agent-003',
    email: 'jean@zenith.bj',
    name: 'Jean Sègbè',
    role: 'agent_terrain',
    organization: 'Agence Zenith Productions',
    isOnline: true,
  },
];

export const getUsersByRole = (role: 'agent_terrain' | 'agence' | 'soebra'): SystemUser[] => {
  return mockSystemUsers.filter(user => user.role === role);
};

export const getAllUsersExcept = (excludeId: string): SystemUser[] => {
  return mockSystemUsers.filter(user => user.id !== excludeId);
};

export const getUserById = (id: string): SystemUser | undefined => {
  return mockSystemUsers.find(user => user.id === id);
};

export const getRoleLabel = (role: string): string => {
  switch (role) {
    case 'agent_terrain':
      return 'Agent Terrain';
    case 'agence':
      return 'Agence';
    case 'soebra':
      return 'SOBEBRA';
    case 'admin':
      return 'Administrateur';
    default:
      return role;
  }
};

export const getRoleColor = (role: string): string => {
  switch (role) {
    case 'agent_terrain':
      return '#1976d2'; // Bleu
    case 'agence':
      return '#2e7d32'; // Vert
    case 'soebra':
      return '#ed6c02'; // Orange
    case 'admin':
      return '#9c27b0'; // Violet
    default:
      return '#757575';
  }
};

